module.exports = __webpack_public_path__ + "static/masterclass-1be85f1ad13ade846d0bd9af0f337e56.png";